<template>
<b-container fluid="sm">
  <b-form inline @submit.prevent="getBidders">
    <label class="mr-sm-2" for="inline-form-custom-select-pref">조달업체 검색</label>
    <b-input-group>
      <b-form-input
        v-model="word"
        :counter="counter"
        :rules="wordRules"
        :placeholder="label + ' 입력'"
        required
        id="word">
      </b-form-input>
      <template v-slot:prepend>
        <b-form-select v-model="type" :options="options" class="mb-2 mr-sm-2 mb-sm-0"></b-form-select>
      </template>
      <template v-slot:append>
        <b-button variant="primary" disabled v-show="isLoading" class="mb-2 mr-sm-2 mb-sm-0">
          <b-spinner small></b-spinner>
          <span class="sr-only">Loading...</span>
        </b-button>
        <b-button variant="primary" @click="getBidders" class="mb-2 mr-sm-2 mb-sm-0">검색</b-button>
      </template>
    </b-input-group>
  </b-form>
    <b-container v-if="numResult > 0" class="m-0 p-0" align="left">
      <b-alert class="m-2" variant="success" show v-if="numResult > 0">모두 {{ numResult }}건이 검색되었습니다.</b-alert>
      <b-table :items="bidders" :fields="fields" striped small stacked="sm" class="m-0 p-0">
        <template v-slot:cell(show_details)="row">
          <b-button size="sm" :variant="row.detailsShowing ? 'secondary' : 'primary'" @click="queryApis(row)">
            상세정보 {{ row.detailsShowing ? '닫기' : '조회'}}
          </b-button>
        </template>
        <template v-slot:row-details="row">
          <b-card>
            <b-row class="mb-2">
              <b-col> 
                <Bidder :bidder="row.item.bidderDetail" />
              </b-col>
            </b-row>
          </b-card>
        </template>
      </b-table>
      <b-container class="text-center" v-if="numResult > 10">
        <b-pagination
          v-model="page"
          :total-rows="numResult"
          :per-page="10"
          @input="paginate"></b-pagination>
      </b-container>
    </b-container>
  </b-container>
</template>

<script>
  import Vue from 'vue'
  import BootstrapVue from 'bootstrap-vue'
  import Bidder from './Bidder'
  Vue.use(BootstrapVue)
  
  export default {
    components: { Bidder },
    data: () => ({
      filters: null,
      orderBy: null,
      numResult: 0,
      page: 1,
      bidders: [],
      type: 'corpNm',
      valid: true,
      word: '',
      wordRules: [
        v => !!v || '검색어는 필수'
      ],
      fields: [
        { key: 'bizno', label: '사업자등록번호' },
        { key: 'ceoNm', label: '대표자' },
        { key: 'corpNm', label: '업체명' },
        { key: 'adrs', label: '주소' },
        { key: 'show_details', label: '상세정보' }
      ],
      isLoading: false,
      options: [
        { value: 'bizno', text: '사업자등록번호' },
        { value: 'corpNm', text: '업체명' },
        { value: 'ceoNm', text: '대표자명' },
      ],
      bidderDetail: null
    }),

    methods: {
      format () {
        if (this.type === 'bizno') {
          var x = this.word.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
          this.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
        }
      },
      validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
        }
      },
      reset () {
        this.$refs.form.reset()
      },
      clearInput (type) {
        this.word = ''
        this.type = type
      },
      async getBidders () {
        this.bidders = []
        this.isLoading = true
        let op = null
        let value = null
        if (this.type === 'bizno') {
          op = 'eq'
          value = this.word
        } 
        else {
          op = 'like'
          value = `%${this.word}%`
        }
        this.filters = [{ "name": this.type, "op": op, "val": value }]
        try {
          const result = await this.$restBidders(this.filters, this.page)
          if (result.objects.length > 0) {
            this.bidders = result.objects
            this.numResult = result.num_results
          } else {
            alert('검색결과가 없습니다.')
          }
          this.isLoading = false
        } catch (err) {
          console.log(err)
          this.isLoading = false
        }
      },
      async queryApis (row) {
        if (!row.detailsShowing) {
          const result = await this.$queryApis(row.item.bizno)
          row.toggleDetails()
          row.item.bidderDetail = result
        } else {
          row.toggleDetails()
        }
      },
      hideModal() {
        this.$refs['bidder-detail'].hide()
      },
      paginate: async function() {
        try {
          this.isLoading = true
          const result = await this.$restBidders(this.filters, this.page)
          this.bidders = result.objects
          this.isLoading = false
        } catch(err) {
          console.log(err)
          this.isLoading = false
        }
      }
    },
    computed: {
      label () {
        if (this.type === 'bizno') {
          return '사업자등록번호 10자리수'
        } else if (this.type === 'corpNm') {
          return '업체명에 포함된 단어'
        } else {
          return '대표자명'
        }
      },
      counter () {
        if (this.type === '사업자등록번호') {
          return 10
        } else {
          return 30
        }
      },
    }
  }
</script>
<style scoped src="bootstrap/dist/css/bootstrap.css"></style>
<style scoped src="bootstrap-vue/dist/bootstrap-vue.css"></style>
